/* import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
})); */
//

// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}

// Add your custom JS here.
(function($) {
	$(window).scroll(function(){
 		var sticky = $('.navbar'),
      		scroll = $(window).scrollTop();

  		if (scroll > 0) 
			sticky.addClass('bg-white');
  		else 
			sticky.removeClass('bg-white');
	});

    $('.fadeInUp, .fadeInDown, .fadeInLeft, .fadeInRight, .zoomIn, .icon-section .wp-block-columns, h1, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:first-of-type .wp-block-image):not(:has(.wp-block-column:last-of-type .wp-block-image, .wp-block-column:last-of-type .wp-block-cover)) .wp-block-column:first-of-type:has(.wp-block-image), *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:last-of-type .wp-block-image):not(:has(.wp-block-column:first-of-type .wp-block-image, .wp-block-column:first-of-type .wp-block-cover)) .wp-block-column:last-of-type:has(.wp-block-image), .wp-block-button, #sb_instagram, #wrapper-footer-full .wp-block-cover').addClass('hidden');

})(jQuery);

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const logo_swiper = new Swiper('.logo-swiper', {
	modules: [Autoplay, Navigation, Pagination],
    //loop: true,
    slidesPerView: "auto",
	autoHeight: true, // Make slides equal height
	// Navigation arrows
	navigation: {
		nextEl: '.logo-swiper-button-next',
		prevEl: '.logo-swiper-button-prev',
	},
    /* keyboard: {
        enabled: true,
        onlyInViewport: false
    }, */
    on: {
        beforeInit() {
          const slides = this.el.querySelectorAll('.swiper-slide');
    
          if (slides) {
            this.params.loop = slides.length > 3;
          }
        },
    },
});

const content_swiper = new Swiper('.content-swiper', {
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: "auto",
	autoHeight: true, // Make slides equal height
	// Navigation arrows
	navigation: {
		nextEl: '.content-swiper-button-next',
		prevEl: '.content-swiper-button-prev',
	},
    pagination: {
        el: ".content-swiper-pagination",
        clickable: true,
    },
    /* keyboard: {
        enabled: true,
        onlyInViewport: false
    }, */
    on: {
        beforeInit() {
          const slides = this.el.querySelectorAll('.swiper-slide');
    
          if (slides) {
            this.params.loop = slides.length > 3;
          }
        },
    },
});
//

const parents = document.querySelectorAll('.wp-block-columns');

parents.forEach(parent => {
  const children = parent.children;
  if (children.length === 2) {
    parent.classList.add('has-two-children');
  }
});
//

//Animations
import ScrollOut from "scroll-out";
// Fade in Up
ScrollOut({
    targets: '.fadeInUp, .icon-section .wp-block-columns, #sb_instagram',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInUp');
    },
    once: true
});

// Fade in Down
ScrollOut({
    targets: '.fadeInDown, h1',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInDown', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInDown');
    },
    once: true
});

// Slide in Left
ScrollOut({
    targets: '.fadeInLeft, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:first-of-type .wp-block-image):not(:has(.wp-block-column:last-of-type .wp-block-image, .wp-block-column:last-of-type .wp-block-cover)) .wp-block-column:first-of-type:has(.wp-block-image)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInLeft', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInLeft');
    },
    once: true
});

// Slide in Right
ScrollOut({
    targets: '.fadeInRight, *:not(.wp-block-column) > .wp-block-columns.has-two-children:has(.wp-block-column:last-of-type .wp-block-image):not(:has(.wp-block-column:first-of-type .wp-block-image, .wp-block-column:first-of-type .wp-block-cover)) .wp-block-column:last-of-type:has(.wp-block-image), #wrapper-footer-full .wp-block-cover',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInRight', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__fadeInRight');
    },
    once: true
});

// Zoom Fade In
ScrollOut({
    targets: '.zoomIn, .wp-block-button',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__zoomIn', 'hidden');
        // force reflow
        void el.offsetWidth;
        // re-add the animated class
        el.classList.add('animate__animated', 'animate__zoomIn');
    },
    once: true
});